import type {CSSProperties,ReactNode} from "react";
import {Badge,type BadgeKind} from "../../ui";
import type {ProspectOutcome} from "./ProspectListParts";
export function OutcomePanel({ outcome, children }: { outcome: ProspectOutcome; children?: ReactNode }) {
  return (
    <div className="preview-box" style={outcomePanelStyle(outcome.kind)}>
      <div className="row gap-8" style={{ alignItems: "center", flexWrap: "wrap" }}>
        <Badge kind={outcome.kind}>{outcome.label}</Badge>
        <strong>{outcome.title}</strong>
      </div>
      <div style={{ marginTop: 8 }}>{outcome.detail}</div>
      <div className="muted" style={{ marginTop: 4 }}>Prossimo passo: {outcome.next}</div>
      {children}
    </div>
  );
}

function outcomePanelStyle(kind: BadgeKind): CSSProperties {
  if (kind === "muted") {
    return { padding: "12px 14px", lineHeight: 1.5 };
  }
  const borderColor = kind === "accent" ? "var(--accent-line)" : `var(--${kind})`;
  return {
    padding: "12px 14px",
    lineHeight: 1.5,
    background: `var(--${kind}-dim)`,
    borderColor,
  };
}

export function KV({ k, v, sub }: { k: string; v: string; sub?: string }) {
  return (
    <div className="preview-box" style={{ padding: "10px 12px" }}>
      <div className="muted" style={{ fontSize: 10 }}>{k.toUpperCase()}</div>
      <div className="mt-4" style={{ fontSize: 13 }}>{v}</div>
      {sub && <div className="mono muted" style={{ fontSize: 11, marginTop: 2 }}>{sub}</div>}
    </div>
  );
}

export function joinNonEmpty(parts: Array<string | null | undefined>, sep: string): string {
  const filtered = parts.filter((x): x is string => !!x && x.trim().length > 0);
  return filtered.length ? filtered.join(sep) : "—";
}

export function ActionFeedback({ msg, err }: { msg: string | null; err: string | null }) {
  if (!msg && !err) return null;
  return (
    <div role="status" style={{ marginTop: 8, fontSize: 12, color: err ? "var(--danger)" : "var(--accent)" }}>
      {err ?? msg}
    </div>
  );
}
